import React from "react";
import DotLegalDeleteDialogWrapper from "../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useDeleteBestPracticeDocumentTemplateDialog, DeleteBestPracticeDocumentTemplateDialogProps } from "./DeleteBestPracticeDocumentTemplateDialog.hooks";

function DeleteBestPracticeDocumentTemplateDialog(props: DeleteBestPracticeDocumentTemplateDialogProps) {
    const { onDeleteClick, inProgress } = useDeleteBestPracticeDocumentTemplateDialog(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedTemplate.name}
            onDialogClose={props.onDialogClose}
            onOkClick={onDeleteClick}
            inProgress={inProgress}
        />
    );
}

export default DeleteBestPracticeDocumentTemplateDialog;
